import Link from 'next/link'
import { ProductThumbnail } from '@/General/ProductThumbnail'
import { resolveProductSearchThumbnailUrl } from '@/lib/search/resolveProductSearchThumbnailUrl'

export const SearchResult = ({
  inStock,
  objectId,
  thumbnail,
  title,
  productTypeDescription,
  creators,
  salePrice,
  price,
  currencySymbol,
  productUrl,
}: SearchResultProps) => {
  const hasDiscount =
    salePrice !== undefined &&
    salePrice !== null &&
    price !== undefined &&
    price !== null &&
    salePrice > 0 &&
    salePrice < price

  return (
    <div
      key={objectId}
      className="flex py-2 px-4 border-b-[1px] border-gray-300 hover:bg-gray-50"
    >
      <div className="relative group">
        <div className="flex items-center justify-center w-[84px] h-[112px] md:w-[50px] md:h-[70px] rounded-sm aspect-[84/112] bg-gradient-to-br from-gray-100 to-gray-200 border border-gray-200 overflow-hidden">
          <ProductThumbnail
            src={resolveProductSearchThumbnailUrl(thumbnail, 84)}
            alt={title?.trim() || 'Product'}
            className={`w-full h-full object-cover transition-transform duration-200 group-hover:scale-105 ${!inStock ? 'grayscale' : ''}`}
            loading="lazy"
          />
        </div>
        {!inStock && (
          <div className="absolute -top-1 -right-1 bg-red-500 text-white text-xs px-1.5 py-0.5 rounded-full font-medium">
            OOS
          </div>
        )}
      </div>
      <div className="ml-4">
        <div>
          <Link
            className="text-2xl font-bold text-vi-red underline hover:no-underline"
            href={productUrl || '#'}
            prefetch={false}
          >
            {title}
          </Link>
        </div>
        <div className="text-gray-500">
          {productTypeDescription}
          {creators?.trim() ? (
            <>
              {' '}
              by {creators}
            </>
          ) : null}
        </div>
      </div>
      <div className="ml-auto flex items-center justify-center">
        {hasDiscount ? (
          <div className="text-3xl">
            <span className="ml-2 text-white bg-green-600 px-2 py-1 rounded-md mr-2">
              {currencySymbol}
              {salePrice?.toFixed(2)}
            </span>
            <span className="line-through text-gray-500">
              {currencySymbol}
              {price?.toFixed(2)}
            </span>
          </div>
        ) : (
          <div className="text-3xl">
            {currencySymbol}
            {price?.toFixed(2)}
          </div>
        )}
      </div>
    </div>
  )
}

interface SearchResultProps {
  objectId?: string
  thumbnail?: string
  title?: string
  productTypeDescription?: string
  creators?: string
  salePrice?: number | null
  price?: number | null
  currencySymbol: string
  productUrl?: string
  inStock?: boolean
}
